export const FETCH_TIMEOUT = 100;
export const SCREEN_LIMIT = 6;